export default "__VITE_ASSET__CXeh8cam__"